import { cn } from '@virginexperiencedays/tailwind';

import { IconCalendarExperience } from '../../../icons/IconCalendarExperience';
import { IconEmailEnvelope } from '../../../icons/IconEmailEnvelope';
import { IconUpDownSwitch } from '../../../icons/IconUpDownSwitch';

const usps = [
  {
    icon: <IconCalendarExperience height="16" width="16" stroke="var(--text-neutral-faded)" />,
    text: 'Flexible Booking',
  },
  {
    icon: <IconEmailEnvelope height="16" width="16" />,
    text: 'Instant Delivery',
  },
  {
    icon: <IconUpDownSwitch height="16" width="16" />,
    text: 'Free Exchanges',
  },
];

export const ProductUsps = ({ className }: { className?: string }) => {
  return (
    <ul className={cn('my-4 flex items-center justify-center gap-3 p-0', className)}>
      {usps.map(({ icon, text }) => (
        <li
          className="text-neutral-faded flex items-center gap-0.5 text-xs font-medium leading-none"
          key={text}
        >
          {icon}
          {text}
        </li>
      ))}
    </ul>
  );
};
